import React from 'react';
import { mediaMixin } from '@zillow/constellation';
import styled, { css } from 'styled-components';
var StyledErrorWrapper = styled.div.withConfig({
  displayName: "ErrorWrapper__StyledErrorWrapper",
  componentId: "sc-ykwak2-0"
})(["min-height:calc(100vh - 44px);text-align:left;> .content-wrapper{max-width:1280px;margin-left:auto;margin-right:auto;padding:20px;}display:block;flex-direction:column;justify-content:center;padding-top:20px;", ";"], mediaMixin('md', css(["min-height:calc(100vh + 1px - 50px);"])));

var ErrorWrapper = function ErrorWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(StyledErrorWrapper, null, /*#__PURE__*/React.createElement("main", {
    className: "content-wrapper"
  }, children));
};

export default ErrorWrapper;
//# sourceMappingURL=ErrorWrapper.js.map